import { render, staticRenderFns } from "./ConfigurationAnchorStep.vue?vue&type=template&id=3cf922fe&scoped=true&"
import script from "./ConfigurationAnchorStep.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationAnchorStep.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationAnchorStep.vue?vue&type=style&index=0&id=3cf922fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf922fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
